import { render, staticRenderFns } from "./GangDialog.vue?vue&type=template&id=5172f050&scoped=true"
import script from "./GangDialog.vue?vue&type=script&lang=js"
export * from "./GangDialog.vue?vue&type=script&lang=js"
import style0 from "./GangDialog.vue?vue&type=style&index=0&id=5172f050&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5172f050",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5172f050')) {
      api.createRecord('5172f050', component.options)
    } else {
      api.reload('5172f050', component.options)
    }
    module.hot.accept("./GangDialog.vue?vue&type=template&id=5172f050&scoped=true", function () {
      api.rerender('5172f050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/dialogs/GangDialog.vue"
export default component.exports